import React from 'react';
import intl from "react-intl-universal";
import {observer} from "mobx-react-lite";
import {useAppState, useRootStore} from "@stores/AppStateContext";

import {Workspace} from "../../../../API";

import {MODALS} from "../../../screens/modals/modal-names";

import {ContextMenu} from '../../../components/ContextMenu';

export interface WorkspaceContextMenuProps {
    workspace: Workspace,
    handleClose: () => void,
    isDark: boolean
}

export const WorkspaceContextMenu = observer(({workspace, handleClose, isDark}: WorkspaceContextMenuProps) => {
    const appState = useAppState();
    const rootStore = useRootStore();
    return (
        <ContextMenu
            isDark={isDark}
            handleClose={handleClose}
            items={[
                {
                    onClick: () => {
                        appState.setModal({name: MODALS.ADD_MEMBERS_WORKSPACE, params:{workspace}})
                        appState.setContextMenu(null)
                    },
                    text: intl.get('Ws.context-menu.addMembers').d('Add members...'),
                },
                {
                    onClick: () => {
                        rootStore.view.openPageByName('wsGeneral', {wsSlug: workspace.slug!});
                        appState.setContextMenu(null)
                    },
                    text: intl.get('Ws.context-menu.addMembers.WorkspaceSettings').d('Workspace Settings'),
                },
            ]}
        />
    )
})
